
<ng-container [formGroup]="dateFormGroup">
  <div fxLayout='row' fxLayout.lt-md='column'>
    <mat-form-field appearance='outline' class='filter-date-input field' >
      <mat-label>{{data.options.from.place_holder}}</mat-label>
      <input formControlName='{{data.options.from.key}}' name='{{data.options.from.key}}' matInput [matDatepicker]='from'>
      <mat-datepicker-toggle matSuffix [for]='from'></mat-datepicker-toggle>
      <mat-datepicker #from></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance='outline' class='filter-date-input field'>
      <mat-label>{{data.options.to.place_holder}}</mat-label>
      <input formControlName='{{data.options.to.key}}' name='{{data.options.to.key}}' matInput [matDatepicker]='to'>
      <mat-datepicker-toggle matSuffix [for]='to'></mat-datepicker-toggle>
      <mat-datepicker #to></mat-datepicker>
    </mat-form-field>
  </div>
</ng-container>
